module.exports = __webpack_public_path__ + "static/media/AVISOIMPORTANTEdiciembre2025.32d8ab41.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/AVISOIMPORTANTEdiciembre2025.pdf
// module id = 967
// module chunks = 0